import { Component, inject } from '@angular/core';
import { ShiftWorkingDayService } from 'orchestrator';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  ShiftWorkingDayCreateDto,
  ShiftWorkingDayDto,
  ShiftWorkingDayExcelDownloadDto,
  ShiftWorkingDayUpdateDto,
} from '../proxy/controlling/dtos/shift-working-day';
import { SHIFTWORKINGDAY_CONFIG, SHIFTWORKINGDAY_FIELDS } from './shift-working-day.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-shift-working-day',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, ShiftWorkingDayService, ConfirmationService],
  templateUrl: './shift-working-day.html',
  styleUrl: './shift-working-day.scss',
})
export class ShiftWorkingDay extends BaseCrudComponent<
  ShiftWorkingDayDto,
  ShiftWorkingDayCreateDto,
  ShiftWorkingDayUpdateDto,
  ShiftWorkingDayExcelDownloadDto
> {
  service = inject(ShiftWorkingDayService);
  config = SHIFTWORKINGDAY_CONFIG;
  fields = SHIFTWORKINGDAY_FIELDS;

  protected prepareUpdateDto(data: any, selected: ShiftWorkingDayDto): ShiftWorkingDayUpdateDto {
    return {
      mustInform: data.mustInform,
      shiftId: data.shiftId,
      dayId: data.dayId,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'ShiftWorkingDay';
  }
}
